<template>
  <div class="w-1/4 cursor-pointer flex inputfloat clear-both text-gray-600 hover:text-gray-700">
    <span class="minus-button">
      <icon name="close" />
    </span>
    <span class="text text-base ml-3 mt-1.5 flex-initial">
      {{ name }}
    </span>
  </div>
</template>

<script>
import Icon from './Icon';
export default {
  props: ['name'],
  components: {
    Icon,
  }
};
</script>